import { Directive, ElementRef, booleanAttribute, computed, inject, input } from '@angular/core';

export type ChipTone = 'neutral' | 'gold';

/**
 * Chip de la maquette : catégorie, type de prix, filtre, succès débloqué.
 *
 * À poser sur un `<span>` quand le chip affiche une information, et sur un
 * `<button>` quand il est cliquable. Dans ce second cas `aria-pressed` reflète
 * l'état sélectionné, ce qui rend le filtre annonçable par un lecteur d'écran.
 * Un chip qui ne serait qu'un `<div>` coloré ne le serait pas.
 */
@Directive({
  selector: '[ctChip]',
  host: {
    class: 'ct-chip',
    '[class.ct-chip--on]': 'selected()',
    '[class.ct-chip--gold]': "tone() === 'gold'",
    '[attr.aria-pressed]': 'pressed()',
  },
})
export class CtChip {
  readonly selected = input(false, { transform: booleanAttribute });

  /** « gold » est réservé à l'anti-gaspi. */
  readonly tone = input<ChipTone>('neutral');

  /**
   * `aria-pressed` n'est valide que sur un élément au rôle `button`. On lit donc
   * la balise hôte plutôt que d'exiger du développeur un drapeau
   * supplémentaire : un chip informatif n'émet pas l'attribut, un chip cliquable
   * l'émet toujours, sans qu'on puisse l'oublier.
   */
  private readonly isButton =
    inject<ElementRef<HTMLElement>>(ElementRef).nativeElement.tagName === 'BUTTON';

  protected readonly pressed = computed(() => (this.isButton ? String(this.selected()) : null));
}
